export enum BackgroundImageType {
  GENERAL = 'GENERAL',
  TENANT = 'TENANT',
  USER = 'USER',
  GENERAL_DEFAULT = 'GENERAL_DEFAULT',
}
